import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { UserCard } from './UserCard';
import PropTypes from 'prop-types';
import { UserUpdateForm } from '../../forms/UserUpdateForm';

export const PersonalData = ({ user, userLogged }) => (
  <Card className="bg-white">
    <Card.Header className="border-bottom">
      <Card.Title>Ficha Personal</Card.Title>
    </Card.Header>

    <Card.Body>
      <Card.Text>
        Información Personal de{' '}
        <span className="text-decoration-underline fw-bold">
          {user?.fullname}
        </span>
      </Card.Text>

      <UserCard user={user} userLogged={userLogged} />

      {userLogged?.typeOfUser !== 'admin' && (
        <Row>
          <Col>
            <UserUpdateForm user={user} />
          </Col>
        </Row>
      )}
    </Card.Body>
  </Card>
);
PersonalData.propTypes = {
  user: PropTypes.object,
  userLogged: PropTypes.object
};
